
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/addPanelInfra/newAddPanel/components/logo/logoSection.scss.css.virtualfile';
        module.exports = {"illustration":"_illustration_brstp_1"};